import type { TableOptionsResolved } from './types.js';
import { isDev } from '../../../../core/utils/is-node-environment.js';
import type { DataTableV2RowData } from '../../public.api.js';

export function getMemoOptions<TData extends DataTableV2RowData>(
  tableOptions: Partial<TableOptionsResolved<TData>>,
  debugLevel:
    | 'debugAll'
    | 'debugCells'
    | 'debugTable'
    | 'debugColumns'
    | 'debugRows'
    | 'debugHeaders',
  key: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (result: any) => void,
) {
  return {
    debug: () => tableOptions?.debugAll ?? tableOptions[debugLevel],
    key: isDev() && key,
    onChange,
  };
}
